import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Col,FormCheckbox } from "shards-react";
import { MDBBtn, MDBIcon } from "mdbreact";
import { Link } from "react-router-dom";

const PageTitle = ({ title, subtitle, className,baseName,showAddNew,showGridSwitch,toggleView,toggleValue, ...attrs }) => {
  const classes = classNames(
    className,
    "text-center",
    "text-md-left",
    "mb-sm-0"
  );

  return (
    <Col xs="12" sm="4" className={classes} { ...attrs }>
      
      <Col xs="6"><span className="text-uppercase page-subtitle">{subtitle}</span>
     <span style={{display:'-webkit-inline-box'}}> <h3 className="page-title">{title}
       </h3>
       
       {showAddNew ? 
       <Link to={"/"+baseName+"-add"}> <MDBBtn style={{marginLeft:'20px'}} color="primary">
        <MDBIcon icon="plus" className="mr-1" /> Add New
      </MDBBtn> </Link>: '' }
      
   
      
      </span>
      </Col>

      <Col xs="6">
      {showGridSwitch ?
       <FormCheckbox  onChange={toggleView} toggle small>
    List View
     </FormCheckbox> : ''}
      

      </Col>
  
    </Col>
  )
};

PageTitle.propTypes = {
  /**
   * The page title.
   */
  title: PropTypes.string,
  /**
   * The page subtitle.
   */
  subtitle: PropTypes.string
};

export default PageTitle;
